import { type Configuration, LogLevel } from '@azure/msal-browser';
import { env } from './env';

export const msalConfig: Configuration = {
  auth: {
    clientId: env.authClientId,
    authority: `https://login.microsoftonline.com/${env.authTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: env.isDev ? LogLevel.Warning : LogLevel.Error,
    },
  },
};

export const apiScopes = [`api://referrals.ata.net/${env.authClientId}/access_as_user`];

export const graphScopes = ['User.Read', 'User.ReadBasic.All'];

export const loginRequest = {
  scopes: apiScopes,
};
